import React from "react";
import Joi from "joi-browser";
import Form from "../../comman/form";
import http from "../../services/HttpService";
import config from "../../config.json";

class LoginStep1 extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      documents: {},
      userTypes: [],
      isProcessing: false,
    };
  }

  componentDidMount() {
    const { validId } = this.props;
    if (validId) {
      const data = { ...this.state.data };
      data["validId"] = validId;
      this.setState({ data });
    }
  }

  schema = {
    validId: Joi.string().required().label("Valid ID"),
  };

  doSubmit = async () => {
    const { data, errors } = this.state;
    this.setState({ isProcessing: true });

    try {
      const { data: startResult } = await http.post(
        config.AuthStart || "Auth/start",
        {
          validId: data["validId"],
          portalType: "workbench",
        }
      );

      localStorage.setItem("challengeId", startResult.challengeId);

      const { data: result } = await http.get(
        config.GetUserType + data["validId"]
      );
      data["userType"] = result;
      localStorage.setItem("userType", data["userType"]);
      this.props.handleStep1(data);
    }
    catch (err) {
      const res = err.response;
      let isInactive = res?.data === "inactive" || res?.data?.message === "inactive";

      if (!isInactive) {
        try {
          await http.get(config.GetUserType + data["validId"]);
        } catch (typeErr) {
          if (typeErr.response?.data === "inactive") {
            isInactive = true;
          }
        }
      }

      localStorage.removeItem("challengeId");

      if (isInactive)
        errors["validId"] =
          "Your account has been deactivated, please contact system administrator systemadmin@workfinity.com";
      else errors["validId"] = "Invalid Id";

      this.setState({ errors });
    } finally {
      this.setState({ isProcessing: false });
    }
  };

  componentWillReceiveProps = (nextProps) => {
    const { userError } = nextProps;
    if (userError !== undefined) {
      const { errors } = this.state;
      errors["validId"] = userError;
      this.setState({ errors });
    }
  };

  render() {
    const { type, handleAdLogin, interactionInProgress } = this.props;
    const { isProcessing } = this.state;
    return (
      <React.Fragment>
        {this.renderEnterInput("validId", "Enter Your Valid ID")}
        {/* <div className="form-group">
          <label htmlFor="validId" className="form-control-label">
            Enter Your Valid ID
          </label>
          <input
            type="text"
            className="form-control"
            name="validId"
            id="validId"
            placeholder="Enter Your Valid ID"
            onKeyDown={this.handleEnterKeyPress}
            onChange={this.handleChange}
          />
        </div> */}
        <button
          type="submit"
          className="wf-login-btn-primary"
          style={{
            backgroundColor: `${type === "admin" ? "#298607" : "#2b62a1"}`,
            color: "white",
          }}
          disabled={this.validate() || isProcessing}
          onClick={this.handleSubmit}
        >
          {isProcessing ? (
            <i className="fa fa-refresh fa-spin mr-2" aria-hidden="true"></i>
          ) : null}
          {isProcessing ? "Processing..." : "Next"}
        </button>
        <button
          className="wf-login-btn-ms mt-3"
          onClick={handleAdLogin}
          disabled={interactionInProgress || isProcessing}
        >
          {interactionInProgress ? (
            <i className="fa fa-circle-o-notch fa-spin mr-2"></i>
          ) : (
            <i className="fa fa-windows" style={{ color: "#00a1f1" }}></i>
          )}
          Sign In With Microsoft
        </button>
      </React.Fragment>
    );
  }
}

export default LoginStep1;
